import { cn } from "@/lib/utils";
import { TIcon } from "./icon.type";

export const LinkedInIcon = ({ className }: TIcon) => {
	return (
		<svg viewBox="0 0 16 16" fill="none" className={cn("fill-[#005EAC]", className)}>
			<g clipPath="url(#clip0_1456_2109)">
				<path
					d="M5.00024 13.2188H2.81274V6.15625H5.00024V13.2188ZM5.21851 3.90613C5.21851 3.19897 4.64478 2.625 3.93799 2.625C3.22852 2.625 2.65625 3.19897 2.65625 3.90613C2.65625 4.61353 3.22852 5.1875 3.93799 5.1875C4.64478 5.1875 5.21851 4.61353 5.21851 3.90613ZM13.1875 9.33325C13.1875 7.43738 12.787 6.03125 10.5723 6.03125C9.50806 6.03125 8.7937 6.56348 8.50208 7.11694H8.5V6.15625H6.375V13.2188H8.5V9.71216C8.5 8.79382 8.73376 7.90417 9.87207 7.90417C10.9949 7.90417 11.0312 8.95435 11.0312 9.77051V13.2188H13.1875V9.33325ZM16 14.125V1.875C16 0.841064 15.1589 0 14.125 0H1.875C0.841064 0 0 0.841064 0 1.875V14.125C0 15.1589 0.841064 16 1.875 16H14.125C15.1589 16 16 15.1589 16 14.125ZM14.125 1.25C14.4696 1.25 14.75 1.5304 14.75 1.875V14.125C14.75 14.4696 14.4696 14.75 14.125 14.75H1.875C1.5304 14.75 1.25 14.4696 1.25 14.125V1.875C1.25 1.5304 1.5304 1.25 1.875 1.25H14.125Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1456_2109">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
